import React from 'react';
import {Container} from "./chat-title.styles";

const ChatTitle = ({classes, children}) => {
    return (
        <Container className={['d-flex align-items-center rtl', classes].join(' ')}>
            {children}
        </Container>
    );
};

export default ChatTitle;
